import { logout } from './log_out.function';
import { notify } from './react-toastify.function';

export const handleApiError = (error) => {
  // Don't show error notifications for cancelled/aborted requests
  if (
    error.name === 'AbortError' ||
    error.code === 'ERR_CANCELED' ||
    error.message === 'canceled' ||
    error.message === 'Cancelled'
  ) {
    return;
  }

  if (error?.response?.status === 401) {
    logout();
    // Navigate to login page after logout
    window.location.href = '/';
    return;
  }

  const errorMessage =
    error?.response?.data?.message ||
    error?.response?.message ||
    error?.message ||
    'An unexpected error occurred';

  notify('error', errorMessage);
};
